"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _Main = _interopRequireDefault(require("./Main.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var cx = _bind["default"].bind(_Main["default"]);

function Main(_ref) {
  var anchor = _ref.anchor,
      children = _ref.children;
  var classes = cx('main', {
    'main--top': anchor === 'top',
    'main--right': anchor === 'right',
    'main--bottom': anchor === 'bottom',
    'main--left': anchor === 'left'
  });
  return _react["default"].createElement("div", {
    className: classes
  }, children);
}

Main.displayName = 'Main';
Main.propTypes = {
  anchor: _propTypes["default"].string,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired
};
Main.defaultProps = {
  anchor: 'left'
};
var _default = Main;
exports["default"] = _default;